import { useMutation } from "react-query";
import { RemoveAttachmentRequestParams, removeAttachment } from "store/api/api";
import { handleAxiosError } from "store/util";
import { MUTATION_KEYS } from "../queryKeys";

const removeAttachmentFn = async (params: RemoveAttachmentRequestParams) => {
  return await removeAttachment(params);
};

export function useRemoveAttachment() {
  return useMutation(removeAttachmentFn, {
    mutationKey: MUTATION_KEYS.removeAttachment,
    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
